import * as tslib_1 from "tslib";
import { TextureProjectorEvent } from "@awayjs/scene";
import { ShadingMethodBase } from "./ShadingMethodBase";
/**
 * ProjectiveTextureMethod is a material method used to project a texture unto the surface of an object.
 * This can be used for various effects apart from acting like a normal projector, such as projecting fake shadows
 * unto a surface, the impact of light coming through a stained glass window, ...
 */
var EffectProjectiveTextureMethod = (function (_super) {
    tslib_1.__extends(EffectProjectiveTextureMethod, _super);
    /**
     * Creates a new ProjectiveTextureMethod object.
     *
     * @param projector The TextureProjector object that defines the projection properties as well as the texture.
     * @param mode The blend mode with which the texture is blended unto the surface.
     *
     * @see away3d.entities.TextureProjector
     */
    function EffectProjectiveTextureMethod(projector, mode, exposure) {
        if (mode === void 0) { mode = "multiply"; }
        if (exposure === void 0) { exposure = 1; }
        var _this = _super.call(this) || this;
        _this._onTextureChangedDelegate = function (event) { return _this._onTextureChanged(event); };
        _this._projector = projector;
        _this._exposure = exposure;
        _this._mode = mode;
        _this._projector.addEventListener(TextureProjectorEvent.TEXTURE_CHANGE, _this._onTextureChangedDelegate);
        return _this;
    }
    Object.defineProperty(EffectProjectiveTextureMethod.prototype, "assetType", {
        /**
         * @inheritDoc
         */
        get: function () {
            return EffectProjectiveTextureMethod.assetType;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectProjectiveTextureMethod.prototype, "exposure", {
        /**
         *
         */
        get: function () {
            return this._exposure;
        },
        set: function (value) {
            if (this._exposure == value)
                return;
            this._exposure = value;
            this.invalidate();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectProjectiveTextureMethod.prototype, "mode", {
        /**
         * The blend mode with which the texture is blended unto the object.
         * ProjectiveTextureMethod.MULTIPLY can be used to project shadows. To prevent clamping, the texture's alpha should be white!
         * ProjectiveTextureMethod.ADD can be used to project light, such as a slide projector or light coming through stained glass. To prevent clamping, the texture's alpha should be black!
         * ProjectiveTextureMethod.MIX provides normal alpha blending. To prevent clamping, the texture's alpha should be transparent!
         */
        get: function () {
            return this._mode;
        },
        set: function (value) {
            if (this._mode == value)
                return;
            this._mode = value;
            this.invalidateShaderProgram();
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(EffectProjectiveTextureMethod.prototype, "projector", {
        /**
         * The TextureProjector object that defines the projection properties as well as the texture.
         *
         * @see away3d.entities.TextureProjector
         */
        get: function () {
            return this._projector;
        },
        set: function (value) {
            if (this._projector == value)
                return;
            if (this._projector)
                this._projector.removeEventListener(TextureProjectorEvent.TEXTURE_CHANGE, this._onTextureChangedDelegate);
            this._projector = value;
            if (this._projector)
                this._projector.addEventListener(TextureProjectorEvent.TEXTURE_CHANGE, this._onTextureChangedDelegate);
            this.updateTexture();
        },
        enumerable: true,
        configurable: true
    });
    EffectProjectiveTextureMethod.prototype._onTextureChanged = function (event) {
        this.updateTexture();
    };
    EffectProjectiveTextureMethod.prototype.updateTexture = function () {
        if (this._texture)
            this.iRemoveTexture(this._texture);
        this._texture = (this._projector) ? this._projector.texture : null;
        if (this._texture)
            this.iAddTexture(this._texture);
        this.invalidateShaderProgram();
    };
    return EffectProjectiveTextureMethod;
}(ShadingMethodBase));
export { EffectProjectiveTextureMethod };
EffectProjectiveTextureMethod.OVERLAY = "overlay";
EffectProjectiveTextureMethod.MULTIPLY = "multiply";
EffectProjectiveTextureMethod.ADD = "add";
EffectProjectiveTextureMethod.MIX = "mix";
EffectProjectiveTextureMethod.assetType = "[asset EffectProjectiveTextureMethod]";



// WEBPACK FOOTER //
// ../dist/lib/methods/EffectProjectiveTextureMethod.js